// TODO: Remove the any type and replace with a proper type.
import { Injectable, Injector } from '@angular/core';

import { SummaryService } from './summary.service';
import { BaseReportService } from './reportBase.service';
import type { IGetReportData, TSummary } from '@shared/models';

@Injectable()
export class ReportDashboardSummaryService extends BaseReportService implements IGetReportData {
    private summaryService: SummaryService;

    constructor(injector: Injector) {
        super(injector);
        this.summaryService = injector.get(SummaryService);
    }

    public async getReportData(): Promise<any> {
        // const fmt = DateTimeFormats.ReverseFull;
        // let reportColValues: string[];
        // let rowInfo: any;
        const allRows: any[] = [];

        const summary = await this.summaryService.getByUid('overallSummary') as TSummary;

        // Counts
        const campaignsCount = summary?.numCampaigns || 0;
        const customersCount = summary?.numCustomers || 0;
        const routesCount = summary?.numRoutes || 0;
        const serviceAreasCount = summary?.numServiceAreas || 0;
        const shuttlesCount = summary?.numShuttles || 0;
        const ticketsCount = summary?.numTickets || 0;
        const tripsCount = summary?.numTrips || 0;
        const usersCount = summary?.numUsers || 0;

        const smsTicketCreatedCount = summary?.smsTicketCreated || 0;
        const smsAllAboardCount = summary?.smsAllAboard || 0;
        const smsDropoffCompletedCount = summary?.smsDropoffCompleted || 0;
        const smsPickupApproachingCount = summary?.smsPickupApproaching || 0;
        const smsPickupArrivedCount = summary?.smsPickupArrived || 0;
        const smsPickupCompletedCount = summary?.smsPickupCompleted || 0;
        const smsTotalCount = smsTicketCreatedCount + smsAllAboardCount +
            smsDropoffCompletedCount + smsPickupApproachingCount +
            smsPickupArrivedCount + smsPickupCompletedCount;

        //
        this.addSummaryRow(['Campaigns:', campaignsCount.toString()], allRows);
        this.addSummaryRow(['Customers:', customersCount.toString()], allRows);
        this.addSummaryRow(['Routes:', routesCount.toString()], allRows);
        this.addSummaryRow(['Service Areas:', serviceAreasCount.toString()], allRows);
        this.addSummaryRow(['Shuttles:', shuttlesCount.toString()], allRows);
        this.addSummaryRow(['Tickets:', ticketsCount.toString()], allRows);
        this.addSummaryRow(['Trips:', tripsCount.toString()], allRows);
        this.addSummaryRow(['Users:', usersCount.toString()], allRows);

        // Sms Messages
        this.addSummaryRow(['Ticket Created Messages:', smsTicketCreatedCount.toString()], allRows);
        this.addSummaryRow(['All Aboard Messages:', smsAllAboardCount.toString()], allRows);
        this.addSummaryRow(['Dropoff Completed Messages:', smsDropoffCompletedCount.toString()], allRows);
        this.addSummaryRow(['Pickup Approaching Messages:', smsPickupApproachingCount.toString()], allRows);
        this.addSummaryRow(['Pickup Arrived Messages:', smsPickupArrivedCount.toString()], allRows);
        this.addSummaryRow(['Pickup Completed Messages:', smsPickupCompletedCount.toString()], allRows);

        // Now show a blank row.
        this.addSummaryRow([' ', ' '], allRows);

        // Show the summary row.
        this.addSummaryRow(['Summary:', 'Total SMS Messages: ' + smsTotalCount.toString()], allRows);

        // End of report data.
        allRows.push(undefined);
        const reportData = { 'data': allRows };
        return reportData;
    }

    // private addSummaryRow(columns, allRows) {
    //     const rowInfo = super.buildRowInfo(columns, 'summary');
    //     allRows.push(rowInfo);
    // }
}
